<div class="relative" *ngIf="(currentLocale$ | async) as locale">
  <app-button-icon icon="/assets/images/locale-{{ locale }}.png" (click)="toggle()"></app-button-icon>

  <div class="bg-white absolute position right-0 shadow-card rounded-md triangle-below transition-opacity" [class.opacity-0]="!show" [class.pointer-events-none]="!show">
    <div *ngFor="let language of languages" class="px-4 rounded-md cursor-pointer py-2 text-xxs font-medium text-gray-900 hover:bg-gray-50" (click)="select(language)" [class.text-primary-one]="isActive(language)">
      {{ ('language.' + language) | translate }}
    </div>
  </div>
</div>
